import { render, staticRenderFns } from "./HeaderViewType.vue?vue&type=template&id=2dd139d0&"
import script from "./HeaderViewType.vue?vue&type=script&lang=js&"
export * from "./HeaderViewType.vue?vue&type=script&lang=js&"
import style0 from "./HeaderViewType.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports